import { BankStatement } from '../../bank/model/bank-statement';
import { UserTransaction } from './user-transaction';

export class UserExtracts {
  statement?: BankStatement;
  transactions?: UserTransaction[];
}
